// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WAMe2r4_hthHvPDxIbIp {
  max-width: 100px;
  max-height: 100px;
}
.wtuxdD0VLDufviTmYsok {
  width: 700px;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/Equipments/Item/Basic/index.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;AACF;AAEA;EACE,YAAA;AAAF","sourcesContent":[".equipImage {\n  max-width: 100px;\n  max-height: 100px;\n}\n\n.form {\n  width: 700px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipImage": `WAMe2r4_hthHvPDxIbIp`,
	"form": `wtuxdD0VLDufviTmYsok`
};
export default ___CSS_LOADER_EXPORT___;
